module.exports = __webpack_public_path__ + "static/media/appliation-rose.aed942aa.png";